module.exports = __webpack_public_path__ + "img/assess.50e1b186.svg";